var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZapMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ZapMini") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Feekpoints",
    d: "M13.9241 7.4187C13.7741 7.0487 13.4041 6.7987 13.0041 6.7987H9.18408L9.99408 1.9587C10.0641 1.5287 9.85408 1.1087 9.46408 0.908705C9.07408 0.708705 8.60408 0.778705 8.29408 1.0887L0.294078 9.08871C0.00407821 9.37871 -0.0759218 9.80871 0.0740782 10.1787C0.224078 10.5487 0.594078 10.7987 0.994078 10.7987H4.81408L4.00408 15.6387C3.93408 16.0687 4.14408 16.4887 4.53408 16.6887C4.68408 16.7587 4.83408 16.7987 4.99408 16.7987C5.25408 16.7987 5.50408 16.6987 5.70408 16.5087L13.7041 8.5087C13.9941 8.2187 14.0741 7.7887 13.9241 7.4187ZM6.50408 12.8887L6.99408 9.96871C7.04408 9.67871 6.96408 9.37871 6.77408 9.1587C6.58408 8.9387 6.30408 8.80871 6.01408 8.80871H3.42408L7.50408 4.7087L7.01408 7.6287C6.96408 7.9187 7.04408 8.2187 7.23408 8.4387C7.42408 8.6587 7.70408 8.7887 7.99408 8.7887H10.5841L6.49408 12.8787L6.50408 12.8887Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapMini);
export default __webpack_public_path__ + "static/media/ZapMini.9c1140d147581675fd59461bb17327dd.svg";
export { ForwardRef as ReactComponent };